$(document).on('click', '[data-remove-parent]', function (e) {
  e.preventDefault();
  const parentSelector = $(this).data('remove-parent');
  const parent = $(this).closest(parentSelector);
  parent.fadeOut(300, () => { parent.remove(); });
});
